import {Controller} from "@hotwired/stimulus"
import {config} from "../sneat/config";
import ApexCharts from "apexcharts-clevision";

let cardColor, headingColor, axisColor, shadeColor, borderColor;

cardColor = config.colors.white;
headingColor = config.colors.headingColor;
axisColor = config.colors.axisColor;
borderColor = config.colors.borderColor;

const formatPercent = (done, total) => {
  if (typeof done === "undefined" && typeof total === "undefined") {
    return null

  } if (total === 0) {
    return 100

  } else {
    return ((done / total) * 100).toFixed(0)
  }
}
// Connects to data-controller="sprints-chart"
export default class extends Controller {
  static values = {
    data: Object,
    names: Array
  }

  connect() {
    let series = []
    Object.keys(this.dataValue).forEach((member, sprint_points) => {
      series.push({
        name: member, data: this.dataValue[member].map((sp) => formatPercent(sp.done, sp.total))
      })
    })
    let options = {
      series: series,
      chart: {
        height: 350,
        type: 'line',
      },
      colors: ['#696cff', '#8592a3', '#71dd37', '#03c3ec', '#ffab00', '#233446'],
      xaxis: {
        categories: this.namesValue,
        labels: {
          style: {
            fontSize: '13px',
            colors: axisColor
          }
        },
        axisTicks: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '13px',
            colors: axisColor
          }
        },
        min: 0,
        max: 100,

      },
    };
    var chart = new ApexCharts(document.querySelector("#sprintsChart"), options);
    chart.render();

    console.log(this.dataValue)
  }
}
